import { useQuery } from '@tanstack/react-query'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { throwIfApiError } from '@omnea-app/packages/universal/error-handling/throwifApiError'
import { RequestsHttpClient } from '@omnea-app/requests/requestsHttpClient'

export const pauseDetailQueryKey = (requestId: string) => ['pause-detail', requestId]

const useGetPauseDetail = (requestId: string) => {
  const { getToken } = useAuthenticatedUser()

  return useQuery({
    queryKey: pauseDetailQueryKey(requestId),
    queryFn: async () => {
      const apiClient = new RequestsHttpClient({ authorization: await getToken() })

      const { data, error } = await apiClient.GET('/{id}/pause', { params: { path: { id: requestId } } })

      throwIfApiError(error)

      return data
    },
  })
}

export { useGetPauseDetail }
